import { render } from "./qzfTabs.vue?vue&type=template&id=dc16a280&scoped=true"
import script from "./qzfTabs.vue?vue&type=script&lang=js"
export * from "./qzfTabs.vue?vue&type=script&lang=js"

import "./qzfTabs.vue?vue&type=style&index=0&id=dc16a280&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/jk-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc16a280"]])

export default __exports__